/**
 * Free gift promo: 1 gift per 3 units of the main variant.
 * Main 1–3 → 1 gift, 4–6 → 2 gifts, 7–9 → 3 gifts, etc.
 */
window.FreeGiftPromo = {
  MAIN_VARIANT_ID: '57030411649348',
  FREE_VARIANT_ID: '55947861360964',
  UNITS_PER_GIFT: 3,
  _syncing: false,

  getRequiredGiftQty(mainQty) {
    const qty = Number(mainQty) || 0;
    if (qty <= 0) return 0;
    return Math.ceil(qty / this.UNITS_PER_GIFT);
  },

  getMainQuantity(cart) {
    return (cart.items || [])
      .filter((item) => String(item.variant_id) === this.MAIN_VARIANT_ID)
      .reduce((sum, item) => sum + item.quantity, 0);
  },

  getGiftItem(cart) {
    return (cart.items || []).find((item) => String(item.variant_id) === this.FREE_VARIANT_ID);
  },

  /**
   * Ensures gift line quantity matches the main product quantity rules.
   * @returns {Promise<object|null>} Updated cart payload (with sections when requested), or null if unchanged/failed.
   */
  async sync({ sections, sections_url } = {}) {
    if (this._syncing) return null;
    this._syncing = true;

    try {
      const cart = await fetch(`${routes.cart_url}.js`).then((res) => res.json());
      const required = this.getRequiredGiftQty(this.getMainQuantity(cart));
      const giftItem = this.getGiftItem(cart);
      const current = giftItem ? giftItem.quantity : 0;

      if (required === current) return null;

      if (required > 0 && !giftItem) {
        const addResponse = await fetch(routes.cart_add_url, {
          ...fetchConfig('javascript'),
          body: JSON.stringify({
            items: [{ id: Number(this.FREE_VARIANT_ID), quantity: required }],
          }),
        }).then((res) => res.json());

        if (addResponse.status) {
          console.error('Free gift add failed', addResponse);
          return null;
        }
      }

      const body = {
        updates: {
          [this.FREE_VARIANT_ID]: required,
        },
      };

      if (sections) {
        body.sections = sections;
        body.sections_url = sections_url || window.location.pathname;
      }

      const response = await fetch(routes.cart_update_url, {
        ...fetchConfig(),
        body: JSON.stringify(body),
      }).then((res) => res.json());

      if (response.errors) {
        console.error('Free gift sync failed', response.errors);
        return null;
      }

      return response;
    } catch (error) {
      console.error('Free gift sync failed', error);
      return null;
    } finally {
      this._syncing = false;
    }
  },
};
